export const sealingMachines = [
  {
    id: 1,
    name: 'SC-1350 High Speed Rotary Sealing Machine',
    description: 'High Speed Rotary sealer for cups, bowls, trays, and other containers',
    subtitle: 'Big production in a compact package.',
    details: 'The SC-1350 offers big production output in a little package. This machine utilizes a two-station rotating spindle to carry containers into sealing position at rates at up to 25 cycles per minute, producing an output of 1500 pieces per hour in single head configuration. For smaller containers, a dual head tooling can be designed so that with each machine cycle two containers are sealed, providing about double the output.',
    imageUrl: 'https://teinnovations.com/wp-content/uploads/2017/02/1350-cutout-sq.jpg',
    technical: {
      dimensions: '22.5" x 18" x 32"H',
      power: '110V AC',
      weight: '~175 lbs.',
      consumption: '~700W',
      air: '~1CFM @ 100PSI',
      maxCircular: '7" x 4"H',
      maxRectangular: '9" x 7" x 4"H',
      productionSingle: '1500 pieces/hr (optimal)',
      productionDual: '2700 pieces/hr (optimal)'
    }
  },
  {
    id: 2,
    name: 'SC-1360 MAP High Speed Rotary Sealing Machine',
    description: 'High-Speed Rotary MAP sealer for cups, bowls, trays, and other containers.',
    subtitle: 'Modified Atmosphere Packaging for extended shelf life.',
    details: 'The SC-1360 MAP adds a Modified Atmosphere Packaging option to the SC-1350 rotary sealing machine, and continues to high production a relatively small amount of space. During the sealing process an airtight chamber is formed, all the ambient air is removed from the chamber and the package and replaced with the desired gas mixture, and the package is sealed in that environment. This allows for the package to be sealed with an residual oxygen level as low as 0.1%.',
    imageUrl: 'http://teinnovations.com/wp-content/uploads/2017/02/SC-1360-MAP-cutout-e1499294676901.png',
    technical: {
      dimensions: '23" x 19" x 37"H',
      power: '110V AC',
      weight: '~205 lbs.',
      consumption: '~745W',
      air: '~1CFM @ 100PSI',
      maxCircular: '7" x 4"H',
      maxRectangular: '9" x 7" x 4"H',
      productionSingle: '1500 pieces/hr (optimal)',
      productionDual: '2700 pieces/hr (optimal)'
    }
  },
  {
    id: 3,
    name: 'CTS-168L Tray Sealing Machine',
    description: 'Tabletop sealer for trays, large bowls, and sandwich wedges.',
    subtitle: 'Versatile tray sealing for small to medium production.',
    details: 'The CTS-168L is the big brother of the CTS-528 and CTS-528XL. It can accommodate most standard tray sizes over a wide range of depths, and can seal trays with multiple compartments with ease – even sealing the dividers between compartments. The CTS-168L also boasts the Teinnovations Quick-Swap tooling system, so you can switch containers in about 3-4 minutes.',
    imageUrl: 'https://teinnovations.com/wp-content/uploads/2017/07/168L-cutout-sq.jpg',
    technical: {
      dimensions: '16.5" x 24.5" x 25"H',
      power: '110V AC',
      weight: '~130 lbs.',
      consumption: '~600W',
      maxCircular: '7" x 4"H',
      maxRectangular: '9" x 7" x 4"H',
      productionSingle: '600 pieces/hr (optimal)',
      productionDual: '1100 pieces/hr (optimal)'
    }
  },
  {
    id: 4,
    name: 'CTS-168L MAP Sealing Machine',
    description: 'A complete Modified Atmosphere Packaging system based on the CTS-168L tray sealer',
    subtitle: 'Affordable MAP system for extended shelf-life.',
    details: 'The CTS-168L MAP adds a Modified Atmosphere Packaging system to the CTS-168L sealing machine, making it one of the most affordable ways to extend the shelf-life of your products. During the sealing process an airtight chamber is formed, all the ambient air is removed and replaced with the desired gas mixture, allowing for a residual oxygen level as low as 0.1%.',
    imageUrl: 'https://teinnovations.com/wp-content/uploads/2017/07/168LMAP-sq.jpg',
    technical: {
      dimensions: '17" x 17" x 28"H',
      power: '110V AC',
      weight: '~170 lbs.',
      consumption: '~650W',
      maxCircular: '7" x 4"H',
      maxRectangular: '9" x 7" x 4"H',
      productionSingle: '600 pieces/hr (optimal)',
      productionDual: '1100 pieces/hr (optimal)'
    }
  },
  {
    id: 5,
    name: 'CTS-528 Cup Sealing Machine',
    description: 'Tabletop sealer for most cups and small containers',
    subtitle: 'Perfect for beverages and small food items.',
    details: 'The smallest of our semi-automatic machines, the CTS-528 is ideal for most beverages or small food items. Drinks and specialty beverages are a natural fit including fresh juices, smoothies, iced coffee, soft drinks, milkshakes, even water. The CTS-528 is also great for single portion food items such as desserts, fruit cups, salads, yogurts, snacks, candies, and many more.',
    imageUrl: 'https://teinnovations.com/wp-content/uploads/2017/07/528-sq.jpg',
    technical: {
      dimensions: '10.5" x 15" x 23.5"',
      power: '110V AC',
      weight: '~60 lbs.',
      consumption: '~400W',
      maxCircular: '3.9" x 6"H',
      maxRectangular: '3.9" x 3.9" x 6"H',
      production: '700 pieces/hr (optimal)'
    }
  },
  {
    id: 6,
    name: 'CTS-528XL Deli Container Sealing Machine',
    description: 'Tabletop sealer for deli containers, bowls, and large cups',
    subtitle: 'Designed specifically for deli containers.',
    details: 'Building off the reliability and features of the CTS-528 cup sealer, we\'ve designed a slightly larger, "beefed up" version that is ideal for deli containers from a number of different manufacturers. In many cases, one machine can seal the full range of sizes (from 6 oz. to 32 oz.) with no adjustment at all. Perfect for deli items, salads, snacks, cotton candy, hot soups, fruit cups, sauces, and salsas.',
    imageUrl: 'https://teinnovations.com/wp-content/uploads/2017/07/528XL-sq.jpg',
    technical: {
      dimensions: '11.8" x 16.2" x 23.5"H',
      power: '110V AC',
      weight: '~80 lbs.',
      consumption: '~430W',
      maxCircular: '4.75" x 6"H',
      maxRectangular: '4.75" x 4.75" x 6"H',
      production: '700 pieces/hr (optimal)'
    }
  },
  {
    id: 7,
    name: 'MHS-300 Manual Heat Sealing Machine',
    description: 'Counter-top heat-sealing machine for retail, Home-Meal-Replacement (HMR) menu, and food service applications',
    subtitle: 'Compact, versatile sealing for any counter.',
    details: 'The MHS-300 is a counter-top heat-sealing solution designed for retail, HMR menus, and food service operations. This machine features a film staging bar for tight seals, easy-to-read thermometer with adjustable temperature control, and a gas spring return with Silver Stone sealing plate. With its compact footprint and ability to change tray sizes in seconds, the MHS-300 provides a low-cost, versatile option for sealing hot, frozen, fresh, and refrigerated foods with minimal film waste (cut-off less than ¼" from back of tray).',
    imageUrl: 'http://teinnovations.com/wp-content/uploads/2025/09/MHS300.png',
    technical: {
      dimensions: '25.75" x 14" x 9.25"H (closed) / 21.5"H (open)',
      power: '110V AC, single phase',
      weight: '~38 lbs. (includes one tray carrier)',
      consumption: '10 amps',
      air: 'N/A',
      maxFilmWidth: '9.25"',
      maxFilmRoll: '10" diameter',
      maxTraySize: '10"L x 8"W x 4.5"H',
      productionSingle: 'Manual operation',
      productionDual: 'N/A'
    }
  }
];
